import React, { useEffect, useState } from "react";
import DarkWebFinancialAccount from "./DarkWebFinancialAccount";
import { DialogComponent } from "../../../common/DialogComponent";
import DarkWebFinancialAccountAddBankDialog from "../../../Dialogs/DarkWebFinancialAccountAddBankDialog";
import DarkWebFinancialAccountAddCreditDialog from "../../../Dialogs/DarkWebFinancialAccountAddCreditDialog";
import { MonitorType } from "../../../../util/common";
import { getMonitoring } from "../../../../store/service";
import { GetCountryListAndInternationalSupport } from "../../../../util/countryListAndInternationalSupport";
import { useAreServicesActive } from "../../../../util/CommonServices";
import { idfServiceIds } from "../../../../config/UserServicesList";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../../store";
import { useTranslation } from "react-i18next";
import RenderIcons from "../../../../Assets/css/_icons/partner_icon/RenderIcons";

const DarkWebFinancialAccountList = () => {
    const initialMonitors: any[] = [];
    const [creditMonitors, setCreditMonitors] = useState(initialMonitors);
    const [bankAccountMonitors, setBankAccountMonitors] = useState(initialMonitors);
    const [iBanAccountMonitors, setIBanAccountMonitors]: any = useState({});
    const [iBanAdditionalAccounts, setIBanAdditionalAccounts]: any = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const { supportInternational } = GetCountryListAndInternationalSupport();
    const ibanServiceActive = useAreServicesActive([idfServiceIds.IBANMonitoring]);
    const isIDFPartner = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerDisplayName
            ? state.configurationState.configuration.partnerConfig.isIdfPartner
            : false
    );
    const { t: tLang } = useTranslation();

    const refreshData = () => {
        setIsLoading(true);
        getMonitoring().then((data) => {
            setIsLoading(false);
            const creditCard: any = data.asset.creditCardInformation["monitor-creditcard"];
            const additionalCredit: any = data.asset.creditCardInformation["additional-creditcards"];
            let creditCards = [];

            if (creditCard != null && creditCard["is-monitored"]) {
                creditCards.push(creditCard);
            }

            if (additionalCredit != null) {
                additionalCredit.forEach((obj: any) => {
                    if (obj["is-monitored"]) {
                        creditCards.push(obj);
                    }
                });
            }
            setCreditMonitors(creditCards);
            //===================================bank monitors ===========================================

            const bankAccount: any = data.asset.bankAccountInformation["monitor-bankaccount"];
            const iBanAccount: any = data.asset.ibanAccountInformation["monitor-ibanaccount"];
            const iBanAdditionalAccount: any = data.asset.ibanAccountInformation["additional-ibanaccounts"]
                ? data.asset.ibanAccountInformation["additional-ibanaccounts"]
                : [];
            setIBanAccountMonitors(iBanAccount);
            setIBanAdditionalAccounts(iBanAdditionalAccount);
            const additionalBankAccount: any = data.asset.bankAccountInformation["additional-backaccounts"];
            let bankAccounts = [];

            if (bankAccount != null && bankAccount["is-monitored"]) {
                bankAccounts.push(bankAccount);
            }
            if (additionalBankAccount != null) {
                additionalBankAccount.forEach((obj: any) => {
                    if (obj["is-monitored"]) {
                        bankAccounts.push(obj);
                    }
                });
            }
            setBankAccountMonitors(bankAccounts);
        });
    };

    useEffect(() => {
        refreshData();
    }, []);

    const [showDarkWebFinancialAccountCreditAddDialog, setShowDarkWebFinancialAccountCreditAddDialog] = useState(false);
    const [showDarkWebFinancialAccountBankAccountAddDialog, setShowDarkWebFinancialAccountBankAccountAddDialog] = useState(false);

    const closeDarkWebFinancialAccountBankAccountAddDialog = () => {
        setShowDarkWebFinancialAccountBankAccountAddDialog(false);
    };

    const closeDarkWebFinancialAccountCreditAddDialog = () => {
        setShowDarkWebFinancialAccountCreditAddDialog(false);
    };

    const handleDarkWebFinancialAccountCreditAddDialog = (value: string): any => {
        if (value === "show") {
            setShowDarkWebFinancialAccountCreditAddDialog(true);
        } else if (value === "cancel") {
            document.body.classList.remove("no_scroll");
            setShowDarkWebFinancialAccountCreditAddDialog(false);
        } else if (value === "close") {
            document.body.classList.remove("no_scroll");
            setShowDarkWebFinancialAccountCreditAddDialog(false);
            refreshData();
        }
    };

    const handleDarkWebFinancialAccountBankAccountAddDialog = (value: string): any => {
        if (value === "show") {
            setShowDarkWebFinancialAccountBankAccountAddDialog(true);
        } else if (value === "cancel") {
            document.body.classList.remove("no_scroll");
            setShowDarkWebFinancialAccountBankAccountAddDialog(false);
        } else if (value === "close") {
            document.body.classList.remove("no_scroll");
            setShowDarkWebFinancialAccountBankAccountAddDialog(false);
            refreshData();
        }
    };

    return (
        <React.Fragment>
            <div className={`box offset-padding ${isLoading && "loading"}`}>
                <div className="box-header">
                    <div className="box-title-container">
                        <div className="box-title-icon" aria-hidden="true">
                            <RenderIcons iconName="university" />
                        </div>
                        <div className="box-title-text">
                            <h2 className="box-title">{tLang("identityVault.monitoredInformation.financialAccountWidget.title")}</h2>
                        </div>
                    </div>
                    <div className="box-description">
                        <p>{tLang("identityVault.monitoredInformation.financialAccountWidget.message")}</p>
                    </div>
                </div>
                <div className="box-content">
                    <div className="row between-xs">
                        {creditMonitors != null ? (
                            <div className="col-xs col-no-gutter flex-grow-null">
                                <h3 className="content-sub-title">
                                    {tLang("identityVault.monitoredInformation.financialAccountWidget.cardDetails.title")}{" "}
                                    <span className="count-value">
                                        {"(" + creditMonitors.length + " " + tLang("identityVault.monitoredInformation.financialAccountWidget.outOf") + " 10"}
                                        <span className="sr-only">Used</span>)
                                    </span>
                                </h3>
                            </div>
                        ) : (
                            <></>
                        )}

                        <div className="col-xs col-no-gutter flex-grow-null">
                            <button
                                type="button"
                                className="btn-default btn-primary"
                                data-a11y-dialog-show="dialog-dark-web-financial-account-add"
                                disabled={creditMonitors.length > 9}
                                onClick={() => handleDarkWebFinancialAccountCreditAddDialog("show")}
                            >
                                <span className="btn-text">
                                    {tLang("identityVault.monitoredInformation.financialAccountWidget.cardDetails.addCardPopup.title")}
                                </span>
                            </button>
                        </div>
                    </div>
                    {creditMonitors != null && creditMonitors.length > 0 ? (
                        <div className="data-grid has-lines row-height-md margin-top-s">
                            {creditMonitors.map((monitor, index) => {
                                return (
                                    <DarkWebFinancialAccount
                                        key={"credit" + index}
                                        monitorType={MonitorType.CreditCardMonitoring}
                                        monitorName={"Credit / Debit Card"}
                                        monitorDisplayName={tLang("identityVault.monitoredInformation.financialAccountWidget.cardDetails.displayName")}
                                        accountNumber={monitor["credit-card"]}
                                        isMonitored={monitor["is-monitored"]}
                                        monitorId={monitor["monitor-id"]}
                                        recordId={monitor["record-id"]}
                                        icon={"credit-card"}
                                        onDelete={refreshData}
                                        id={"credit-debit-card" + (index + 1)}
                                    />
                                );
                            })}
                        </div>
                    ) : (
                        <></>
                    )}
                </div>

                <div className="space-divider margin-top-l"></div>

                <div className="box-content">
                    <div className="data-grid has-lines row-height-md margin-top-s">
                        <div className="row between-xs margin-bottom-xs">
                            <h4 className="content-sub-title" style={{ fontSize: "1rem" }}>
                                {tLang("identityVault.monitoredInformation.financialAccountWidget.bankAccount.title")}{" "}
                                <span className="count-value">
                                    {"(" + bankAccountMonitors.length + " " + tLang("identityVault.monitoredInformation.financialAccountWidget.outOf") + " 10"}
                                    <span className="sr-only">Used</span>)
                                </span>
                            </h4>
                            <div className="col-xs col-no-gutter flex-grow-null">
                                <button
                                    type="button"
                                    className="btn-default btn-primary"
                                    data-a11y-dialog-show="dialog-dark-web-financial-account-add"
                                    disabled={
                                        supportInternational
                                            ? Boolean(bankAccountMonitors.length > 9) &&
                                              Boolean(iBanAccountMonitors && iBanAccountMonitors["is-monitored"] && iBanAdditionalAccounts.length === 9)
                                            : ibanServiceActive
                                            ? Boolean(bankAccountMonitors.length > 9) && iBanAdditionalAccounts.length === 9
                                            : Boolean(bankAccountMonitors.length > 9)
                                    }
                                    onClick={() => handleDarkWebFinancialAccountBankAccountAddDialog("show")}
                                >
                                    <span className="btn-text">{tLang("identityVault.monitoredInformation.financialAccountWidget.addAccountButtonText")}</span>
                                </button>
                            </div>
                        </div>

                        {bankAccountMonitors.map((monitor, index) => {
                            return (
                                <DarkWebFinancialAccount
                                    key={"bank-account-" + index}
                                    monitorType={MonitorType.BankAccountMonitoring}
                                    monitorName={"Bank Account"}
                                    monitorDisplayName={tLang("identityVault.monitoredInformation.financialAccountWidget.bankAccount.usBankAccount.title")}
                                    accountNumber={monitor["bank-account"]}
                                    isMonitored={monitor["is-monitored"]}
                                    monitorId={monitor["monitor-id"]}
                                    recordId={monitor["record-id"]}
                                    icon={"university"}
                                    onDelete={refreshData}
                                    id={"bank-account" + (index + 1)}
                                />
                            );
                        })}
                    </div>
                    {supportInternational && (isIDFPartner ? ibanServiceActive : true) && (
                        <div className="data-grid has-lines row-height-md margin-top-s">
                            <h4 className="content-sub-title" style={{ fontSize: "1rem" }}>
                                IBAN{" "}
                                <span className="count-value">
                                    {" "}
                                    {/*Non-US Bank Accounts change to IBAN Account US-24672*/}
                                    {"(" +
                                        (iBanAccountMonitors && iBanAccountMonitors["is-monitored"]
                                            ? iBanAdditionalAccounts.length
                                                ? 1 + iBanAdditionalAccounts.length
                                                : "1"
                                            : "0") +
                                        " " +
                                        tLang("identityVault.monitoredInformation.financialAccountWidget.outOf") +
                                        " 10"}
                                    <span className="sr-only">Used</span>)
                                </span>
                            </h4>
                            {iBanAccountMonitors && iBanAccountMonitors["is-monitored"] && (
                                <DarkWebFinancialAccount
                                    monitorType={MonitorType.IBanAccountMonitoring}
                                    monitorName={"Bank Account"}
                                    monitorDisplayName={tLang("identityVault.monitoredInformation.financialAccountWidget.bankAccount.usBankAccount.title")}
                                    accountNumber={iBanAccountMonitors && iBanAccountMonitors["bank-account"]}
                                    isMonitored={iBanAccountMonitors && iBanAccountMonitors["is-monitored"]}
                                    monitorId={iBanAccountMonitors && iBanAccountMonitors["monitor-id"]}
                                    recordId={iBanAccountMonitors && iBanAccountMonitors["record-id"]}
                                    icon={"university"}
                                    onDelete={refreshData}
                                    id={"bank-account"}
                                ></DarkWebFinancialAccount>
                            )}
                            {iBanAdditionalAccounts.length
                                ? iBanAdditionalAccounts.map((item: any, index: any) => (
                                      <DarkWebFinancialAccount
                                          monitorType={MonitorType.IBanAccountMonitoring}
                                          monitorName={"Bank Account"}
                                          monitorDisplayName={tLang("identityVault.monitoredInformation.financialAccountWidget.bankAccount.usBankAccount.title")}
                                          accountNumber={item["bank-account"]}
                                          isMonitored={item["is-monitored"]}
                                          monitorId={item["monitor-id"]}
                                          recordId={item["record-id"]}
                                          icon={"university"}
                                          onDelete={refreshData}
                                          id={"bank-account" + (index + 1)}
                                      />
                                  ))
                                : null}
                        </div>
                    )}
                </div>
            </div>
            {showDarkWebFinancialAccountCreditAddDialog && (
                <DialogComponent
                    dialogId="dialog-dark-web-financial-account-add-credit"
                    title="Add Account"
                    closeDialog={closeDarkWebFinancialAccountCreditAddDialog}
                >
                    <DarkWebFinancialAccountAddCreditDialog closeDialog={handleDarkWebFinancialAccountCreditAddDialog} />
                </DialogComponent>
            )}
            {showDarkWebFinancialAccountBankAccountAddDialog && (
                <DialogComponent
                    dialogId="dialog-dark-web-financial-account-add-bank-account"
                    title="Add Account"
                    closeDialog={closeDarkWebFinancialAccountBankAccountAddDialog}
                >
                    <DarkWebFinancialAccountAddBankDialog
                        showUsType={bankAccountMonitors.length > 9}
                        disableSelect={
                            Boolean(supportInternational)
                                ? isIDFPartner
                                    ? ibanServiceActive &&
                                      !Boolean(iBanAccountMonitors && iBanAccountMonitors["is-monitored"] && iBanAdditionalAccounts.length === 9)
                                    : !Boolean(iBanAccountMonitors && iBanAccountMonitors["is-monitored"] && iBanAdditionalAccounts.length === 9)
                                : true
                        }
                        supportInternational={supportInternational}
                        closeDialog={handleDarkWebFinancialAccountBankAccountAddDialog}
                    />
                </DialogComponent>
            )}
        </React.Fragment>
    );
};

export default DarkWebFinancialAccountList;
